import request from '../request/request';
import {handleRes} from '../utils/utils';


interface HandleResInterface {
    success: any,
    fail: any,
}
const getDeviceStatistics = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETDeviceStatistics(params);
        const result = handleRes(res, {
            failMes: res.msg
        });
        resolve(result);
    });
};
const getParamKv = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETParamKv(params);
        const result = handleRes(res, {
            failMes: res.msg
        });
        resolve(result);
    });
};

const getCompanyPlan = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request.GETCompanyGetPlanInfo(params);
    const result = handleRes(res, {
      failMes: res.msg
    });
    resolve(result);
  });
};

export {
    getDeviceStatistics,
    getParamKv,
    getCompanyPlan,
};
